import { maxLengthMessage, requiredMessage } from "../validationMessages";

import { trimmedString } from "./trimmedString";

const MAX_LENGTH = 100;

export const cityValidator = trimmedString.max(
  MAX_LENGTH,
  maxLengthMessage(MAX_LENGTH)
);
export const cityValidatorRequired = trimmedString
  .max(MAX_LENGTH, maxLengthMessage(MAX_LENGTH))
  .required(requiredMessage);
